import {TranslationFunction} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";

export const GraphQueryFormatter = {
    formatIsPrivate: (isPrivate: boolean | undefined, _transl: TranslationFunction): string => {
        if (isPrivate) {
            return _transl(CommonTranslationKey.PRIVATE);
        }
        if (!isPrivate) {
            return _transl(CommonTranslationKey.PUBLIC);
        }
        return "";
    }
}
